import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { getQuoteState } from "@MasterBluePrint/Store/Data/Quotes/QuotesSelector";
// import { RfqQuoteDetailsPageContext } from "@insite/content-library/Pages/RfqQuoteDetailsPage";
// import{RfqQuoteDetailPageContext} from "@MasterBluePrint/Pages/RfqQuoteDetailPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});


type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailQuoteNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    quoteNumber?: TypographyProps;
}

export const rfqQuoteDetailQuoteNumberStyles: RfqQuoteDetailQuoteNumberStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;
            font-family: 'Lato',sans-serif;
            font-size: ${themeFontSizes.size18};
            letter-spacing: 0;
            line-height: 1.5rem;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .3125rem;
            margin-right: .3125rem;
            color: ${themeColors.colorPrimary};
            font-size: ${themeFontSizes.size18};
            line height: 1.5rem;
            font-family: 'Roboto', sans-serif;
            font-weight: ${themeFontWeights.fontWeightForBold};
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    quoteNumber: {
        css: css`
            color: ${themeColors.colorCharcoalGrey};
            font-size: 1.125rem;
            line height: 1.5rem;
            font-family: 'Lato',sans-serif;
    `,
    },
    
};

const styles = rfqQuoteDetailQuoteNumberStyles;

const RfqQuoteDetailQuoteNumber = ({
    quoteState,
}: Props) => {
    const quote = quoteState.value;

    if (!quote) {
        return null;
    }
    return (
       
        <StyledWrapper data-test-selector="rfqQuoteDetailsNumber">
             {quote.orderDate && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.titleText} id="quoteNumber">
                        {translate("Quote #")}
                    </Typography>

                    <Typography {...styles.quoteNumber} aria-labelledby="quoteNumber">
                        {quote.quoteNumber}
                    </Typography>
                </StyledWrapper>                
                )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailQuoteNumber),
    definition: {
        displayName: "Quote Detail Quote Number",
      //  allowedContexts: [RfqQuoteDetailPageContext],
        fieldDefinitions: [],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
